import { useEffect, useState } from "react";

export type TImageExists = "loading" | "ok" | "error";

export function useImageExists(imgSrc: string) {
	const [state, setState] = useState<TImageExists>("loading");

	useEffect(() => {
		const img = new Image();

		img.addEventListener("load", () => setState("ok"));
		img.addEventListener("error", () => setState("error"));
		img.src = imgSrc;
	}, []);

	return state;
}
